import { AppInfoLoader } from '@services/AppInfoLoader';
import { UUIDUtils } from '@src/utils';

export class AssociateAppEvent {
    private static generateNewEventId = () => {
        return UUIDUtils.generate();
    };

    private static getCurrentTimestamp = () => {
        return new Date().getTime() / 1000; // Convert to seconds
    };

    public static constructAppEvent = () => {
        return AppInfoLoader.getAppConfig().then((appConfigData) => {
            return {
                storeId: appConfigData.store,
                authId: appConfigData.badgeId,
                deviceId: appConfigData.device.deviceId,
                applicationName: appConfigData.toolName,
                eventId: AssociateAppEvent.generateNewEventId(),
                eventTime: AssociateAppEvent.getCurrentTimestamp(),
            };
        });
    };
}
